import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import { usePageTracking } from "@/hooks/useAnalytics";
import Home from "@/pages/Home";
import Consulting from "@/pages/Consulting";
import Committees from "@/pages/Committees";
import Policy from "@/pages/Policy";
import Chapters from "@/pages/Chapters";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Newsletter from "@/pages/Newsletter";
import Conference from "@/pages/Conference";
import Team from "@/pages/Team";
import Philanthropy from "@/pages/committees/Philanthropy";
import Outreach from "@/pages/committees/Outreach";
import ProfessionalDevelopment from "@/pages/member-resources/ProfessionalDevelopment";
import GeneralInfo from "@/pages/member-resources/GeneralInfo";

function MainLayout() {
  usePageTracking();
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/committees/consulting" element={<Consulting />} />
            <Route path="/committees/policy" element={<Policy />} />
            <Route path="/committees/expansion" element={<Chapters />} />
            <Route path="/committees/outreach" element={<Outreach />} />
            <Route path="/committees" element={<Committees />} />
            <Route path="/member-resources/professional-development" element={<ProfessionalDevelopment />} />
            <Route path="/member-resources/general-info" element={<GeneralInfo />} />
            <Route path="/member-resources/philanthropy" element={<Philanthropy />} />
            <Route path="/newsletter" element={<Newsletter />} />
            <Route path="/conference" element={<Conference />} />
            <Route path="/team" element={<Team />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </>
  );
}

export default App;
